import script from "./FamilyGroupInviteProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupInviteProfile.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupInviteProfile.vue?vue&type=style&index=0&id=7e0dc3d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e0dc3d6"]])

export default __exports__